export const singleCategoryClothingEpicFilterOptions = {
  epicCategories: "omit",
  epicFormality: "omit",
  epicSleeve: {
    displayName: "Sleeve",
    values: [
      {
        displayName: "Sleeveless",
        id: "sleeveless",
      },
      {
        displayName: "Cap Sleeve",
        id: "capsleeve",
      },
      {
        displayName: "Short Sleeve",
        id: "shortsleeve",
      },
      {
        displayName: "3/4 Sleeve",
        id: "34sleeve",
      },
      {
        displayName: "Long Sleeve",
        id: "longsleeve",
      },
    ],
  },
  epicLength: {
    displayName: "Length",
    values: [
      {
        displayName: "Mini",
        id: "mini",
      },
      {
        displayName: "Mid-Thigh Length",
        id: "midthigh",
      },
      {
        displayName: "Knee Length",
        id: "knee",
      },
      {
        displayName: "High Low",
        id: "highlow",
      },
      {
        displayName: "Midi",
        id: "midi",
      },
      {
        displayName: "Floor Length",
        id: "floor",
      },
    ],
  },
  epicNeckline: {
    displayName: "Neckline",
    values: [
      {
        displayName: "Boat",
        id: "boatneck",
      },
      {
        displayName: "Collared",
        id: "collared",
      },
      {
        displayName: "Cowl",
        id: "cowlneck",
      },
      {
        displayName: "Crew",
        id: "crewneck",
      },
      {
        displayName: "Halter",
        id: "halterneck",
      },
      {
        displayName: "High Neck",
        id: "highneck",
      },
      {
        displayName: "Mock Neck",
        id: "mockneck",
      },
      {
        displayName: "Off the Shoulder",
        id: "offtheshoulder",
      },
      {
        displayName: "One Shoulder",
        id: "oneshoulder",
      },
      {
        displayName: "Plunge",
        id: "plungeneck",
      },
      {
        displayName: "Scoop",
        id: "scoopneck",
      },
      {
        displayName: "Square",
        id: "squareneck",
      },
      {
        displayName: "Strapless",
        id: "strapless",
      },
      {
        displayName: "Sweetheart",
        id: "sweetheart",
      },
      {
        displayName: "Turtleneck",
        id: "turtleneck",
      },
      {
        displayName: "V-neck",
        id: "vneck",
      },
    ],
  },
};

export default singleCategoryClothingEpicFilterOptions;
export const { epicCategories } = singleCategoryClothingEpicFilterOptions;
